'use strict';
import angular from 'angular';
import _ from 'lodash';
import './private/AdOperations.service';
import './private/AdOperationsManager.service';
import './private/currentUserServerGateway.service';
import './private/getRole.service';
import './private/Partner.service';
import './private/Role.service';
import './private/Sales.service';
import './private/SalesManager.service';
import './private/SalesSupport.service';
import './private/SuperAdmin.service';
import './private/Vendor.service';
import './private/VendorRestricted.service';
import './private/Client.service';
import './private/Viewer.service';
import './private/SalesViewer.service';

angular.module('currentUser.services')
    .factory('CurrentUser', ['$q', '$rootScope', 'CurrentUserServerGateway', 'getRole', function ($q,
                                                                                                  $rootScope,
                                                                                                  CurrentUserServerGateway,
                                                                                                  getRole) {
        let self = {},
            _private = {
                role: null
            };

        self.get = function () {
            return promiseToReturnCurrentUserFromCacheOrTheServer();
        };

        function promiseToReturnCurrentUserFromCacheOrTheServer() {
            return _private.role ? getCachedCurrentUser() : getCurrentUserFromServer();
        }

        function getCachedCurrentUser() {
            return $q(function (resolve) {
                doResolve(resolve);
            });
        }

        function doResolve(resolve) {
            resolve(_private.role);
        }

        function getCurrentUserFromServer() {
            return CurrentUserServerGateway.getLoggedInUser().then(function (data) {
                return $q(function (resolve, reject) {
                    if (setRoleFrom(data)) {
                        doResolve(resolve);
                    } else {
                        reject();
                    }
                });
            });
        }

        function setRoleFrom(data) {
            $rootScope.userRole = data.loggedInUser;
            return data &&
                _.isObject(data.loggedInUser) &&
                _.isString(data.loggedInUser.predefined_role_key) &&
                (_private.role = getRole(data.loggedInUser.predefined_role_key));
        }

        self.set = function (data) {
            setRoleFrom(data);
        };

        return self;
    }])